import doesElementMatchSettings from './does-element-match-settings';

export default {
  doesElementMatchSettings,
};
